import React from "react";
import {Row, Col, BackTop} from "antd";
import { template, setLocalStorage } from "@reco-m/core";
import { ViewComponent, Banner, ImageAuto } from "@reco-w/core-ui";
import { Namespaces, selectionModel } from "@reco-w/selection-models";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Autoplay, Navigation, Pagination, Thumbs } from "swiper";
import { R2040ArticleList } from "src/apps/common/r2040.article.list";
import { Consulting } from "src/apps/consulting/consulting";
SwiperCore.use([Autoplay, Navigation, Pagination, Thumbs]);

export namespace Selection {

    export interface IProps<S extends IState = IState> extends ViewComponent.IProps<S> { }

    export interface IState extends ViewComponent.IState, selectionModel.StateType { }

    export class Component<P extends IProps = IProps, S extends IState = IState> extends ViewComponent.Base<P, S> {
        showloading = false;
        namespace = Namespaces.selection;

        componentMount() {
            window.scroll(0, 0);
            setLocalStorage("selectedMenu", `/selection`);
        }
        componentDidMount() {
            this.dispatch("input", { newsSlides: 3, newsSpace: 60, customerSlides: 5 });
            this.scalePage();
            $(window).resize(() => {
                return this.scalePage();
            });
        }

        scalePage() {
            const width = document.documentElement.clientWidth;
            if (width < 1200) {
                this.dispatch("input", { newsSlides: 1, newsSpace: 0, customerSlides: 2 });
            } else {
                this.dispatch("input", { newsSlides: 3, newsSpace: 60, customerSlides: 5 });
            }
        }

        renderChoose() {
            const problemData = [
                {
                    imgUrl: "assets/images/second/xz-img1.jpg",
                    title: "哪里政策配套最适合自己"
                },
                {
                    imgUrl: "assets/images/second/xz-img2.jpg",
                    title: "哪里园区载体能承载自己"
                },
                {
                    imgUrl: "assets/images/second/xz-img3.jpg",
                    title: "营商环境如何"
                },
                {
                    imgUrl: "assets/images/second/xz-img4.jpg",
                    title: "产业链是否匹配"
                },
                {
                    imgUrl: "assets/images/second/xz-img5.jpg",
                    title: "政府对接是否负责人"
                }
            ]
            return (
                <div className="block-content problem-content">
                    <div className="container">
                        <div className="second-title">
                            <span>选址难题</span>
                        </div>
                        <Row className="problem-grid">
                            {
                                problemData.map((item, i) => {
                                    return (
                                        <Col key={i}>
                                            <div className="problem-grid-item">
                                                <div className="problem-grid-img">
                                                    <ImageAuto.Component src={item.imgUrl} width="100%" height="100%" />
                                                </div>
                                                <div className="problem-grid-write">
                                                    <span>{item.title}</span>
                                                    <div>?</div>
                                                </div>
                                            </div>
                                        </Col>
                                    )
                                })
                            }
                        </Row>
                    </div>
                </div>
            )
        }

        renderProcess() {
            return (
                <div className="block-content process-content">
                    <div className="container">
                        <div className="second-title white-color">
                            <span>服务流程</span>
                        </div>
                        <div className="step-box type2">
                            <div className="step-box-item">
                                <div className="step-box-img"><img src="assets/images/second/lc-icon1.png" /></div>
                                <div className="step-dot" />
                                <div className="step-box-name">前期调研</div>
                            </div>
                            <div className="step-box-item">
                                <div className="step-box-img"><img src="assets/images/second/lc-icon2.png" /></div>
                                <div className="step-dot" />
                                <div className="step-box-name">实地考察</div>
                            </div>
                            <div className="step-box-item">
                                <div className="step-box-img"><img src="assets/images/second/lc-icon3.png" /></div>
                                <div className="step-dot" />
                                <div className="step-box-name">政策匹配</div>
                            </div>
                            <div className="step-box-item">
                                <div className="step-box-img"><img src="assets/images/second/lc-icon4.png" /></div>
                                <div className="step-dot" />
                                <div className="step-box-name">政企洽谈</div>
                            </div>
                            <div className="step-box-item">
                                <div className="step-box-img"><img src="assets/images/second/lc-icon5.png" /></div>
                                <div className="step-dot" />
                                <div className="step-box-name">签约落地</div>
                            </div>
                        </div>
                    </div>
                </div>
            )
        }


        renderGround() {
            return (
                <div className="block-content" style={{ backgroundColor: "#f8f8f8" }}>
                    <div className="container">
                        <div className="second-title">
                            <span>选择我们的理由</span>
                        </div>
                        <Row gutter={{ xs: 15, sm: 15, md: 20 }} className="ground-grid pt15">
                            <Col xs={12} sm={12} md={6}>
                                <div className="ground-grid-item">
                                    <div className="ground-grid-icon"><i className="icon iconfangan" /></div>
                                    <div className="ground-grid-name">定制化选址<br />解决方案</div>
                                </div>
                            </Col>
                            <Col xs={12} sm={12} md={6}>
                                <div className="ground-grid-item">
                                    <div className="ground-grid-icon"><i className="icon iconjingzhun" /></div>
                                    <div className="ground-grid-name">全国范围内<br />精准对接区域</div>
                                </div>
                            </Col>
                            <Col xs={12} sm={12} md={6}>
                                <div className="ground-grid-item">
                                    <div className="ground-grid-icon"><i className="icon iconxuanzhi1" /></div>
                                    <div className="ground-grid-name">大数据AI<br />智能选址</div>
                                </div>
                            </Col>
                            <Col xs={12} sm={12} md={6}>
                                <div className="ground-grid-item">
                                    <div className="ground-grid-icon"><i className="icon iconliucheng" /></div>
                                    <div className="ground-grid-name">全流程<br />服务</div>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </div>
            )
        }


        renderStrategic() {
            const { state } = this.props,
                customerSlides = state!.customerSlides;
            const customerData = [
                { imgUrl: "assets/images/home/customer-logo1.png" },
                { imgUrl: "assets/images/home/customer-logo2.png" },
                { imgUrl: "assets/images/home/customer-logo3.png" },
                { imgUrl: "assets/images/home/customer-logo4.png" },
                { imgUrl: "assets/images/home/customer-logo5.png" },
                { imgUrl: "assets/images/home/customer-logo6.png" },
                { imgUrl: "assets/images/home/customer-logo7.png" },
                { imgUrl: "assets/images/home/customer-logo8.png" },
                { imgUrl: "assets/images/home/customer-logo9.png" },
                { imgUrl: "assets/images/home/customer-logo10.png" },
                { imgUrl: "assets/images/home/customer-logo11.png" },
                { imgUrl: "assets/images/home/customer-logo12.png" },
                { imgUrl: "assets/images/home/customer-logo13.png" },
                { imgUrl: "assets/images/home/customer-logo14.png" },
                { imgUrl: "assets/images/home/customer-logo15.png" },
                { imgUrl: "assets/images/home/customer-logo16.png" },
                { imgUrl: "assets/images/home/customer-logo17.png" },
                { imgUrl: "assets/images/home/customer-logo18.png" },
                { imgUrl: "assets/images/home/customer-logo19.png" },
                { imgUrl: "assets/images/home/customer-logo20.png" }
            ]
            return (
                <div className="block-content">
                    <div className="container">
                        <div className="second-title">
                            <span>企业客户</span>
                        </div>
                        <Swiper
                            slidesPerView={customerSlides}
                            slidesPerColumn={2}
                            className="customer-swiper"
                            style={{ height: 350 }}
                            pagination={true}
                            spaceBetween={30}
                            autoplay={{
                                delay: 2000,
                                disableOnInteraction: false,  //false: 鼠标操作屏幕后继续自动滚屏
                            }}
                        >
                            {customerData.map((item, i) => {
                                return (
                                    <SwiperSlide key={i}>
                                        <div className="customer-img">
                                            <img src={item.imgUrl} />
                                        </div>
                                    </SwiperSlide>
                                );
                            })}
                        </Swiper>
                    </div>
                </div>
            )
        }


        renderNews() {
            // const { state } = this.props,
            //     newsSlides = state!.newsSlides,
            //     newsSpace = state!.newsSpace;
            // const newsData = [
            //     {
            //         imgUrl: "assets/images/home/news-img1.png",
            //         title: "阿里云创新中心-宝马初创车库联合加速营甄选日l临近",
            //         desc: "8月4日，加速营甄选日即将在上海金桥"
            //     },
            //     {
            //         imgUrl: "assets/images/home/news-img2.png",
            //         title: "[R·CEO CLUB 第三期] 科技型小企业专场闭门路演对接会成功举办",
            //         desc: "7月15日，由瑞谷云企&瑞谷科创RECO"
            //     },
            //     {
            //         imgUrl: "assets/images/home/news-img3.png",
            //         title: "虚实共生元宇宙 | R·CEO CLUB区块链专场沙龙成功举办",
            //         desc: "7月8日，由瑞谷云企&瑞谷科创RECO"
            //     },
            //     {
            //         imgUrl: "assets/images/home/news-img1.png",
            //         title: "阿里云创新中心-宝马初创车库联合加速营甄选日l临近",
            //         desc: "8月4日，加速营甄选日即将在上海金桥"
            //     },
            //     {
            //         imgUrl: "assets/images/home/news-img2.png",
            //         title: "[R·CEO CLUB 第三期] 科技型小企业专场闭门路演对接会成功举办",
            //         desc: "7月15日，由瑞谷云企&瑞谷科创RECO"
            //     },
            //     {
            //         imgUrl: "assets/images/home/news-img3.png",
            //         title: "虚实共生元宇宙 | R·CEO CLUB区块链专场沙龙成功举办",
            //         desc: "7月8日，由瑞谷云企&瑞谷科创RECO"
            //     }
            // ]
            return (
                <div className="block-content" style={{ backgroundColor: "#f8f8f8" }}>
                    <div className="container">
                        <div className="second-title">
                            <span>最新动态</span>
                        </div>
                        {this.renderEmbeddedView(R2040ArticleList.Page, {
                            tagIds: ["887893341487677440"]
                        } as any)}
                        {/* <div className="news-swiper-box">
                            <Swiper
                                slidesPerView={newsSlides}
                                className="news-swiper mt10"
                                style={{ height: 460 }}
                                pagination={true}
                                spaceBetween={newsSpace}
                                // autoplay={{
                                //     delay: 3000,
                                //     disableOnInteraction: false,  //false: 鼠标操作屏幕后继续自动滚屏
                                // }}
                            >
                                {newsData.map((item, i) => {
                                    return (
                                        <SwiperSlide key={i}>
                                            <div className="news-swiper-item">
                                                <div className="news-img">
                                                    <ImageAuto.Component src={item.imgUrl} width="100%" height="100%" radius={0} />
                                                </div>
                                                <div className="pg20">
                                                    <Paragraph ellipsis={{rows: 2, expandable: false}} className="mb0 size-18 gray-one-color">
                                                        {item.title}
                                                    </Paragraph>
                                                    <Paragraph ellipsis className="mb0 size-14 gray-three-color mt12">
                                                        {item.desc}
                                                    </Paragraph>
                                                    <div className="mt20">
                                                        <span className="list-arrow" />
                                                    </div>
                                                </div>
                                            </div>
                                        </SwiperSlide>
                                    );
                                })}
                            </Swiper>
                        </div> */}
                    </div>
                </div>
            )
        }

        renderConsult() {
            return <Consulting.Page renderType={1} orderCode="guanwqyxz"></Consulting.Page>
            // return (
            //     <div className="block-content consult-content">
            //         <div className="container">
            //             <div className="second-title line-no white-color">
            //                 <span>立即咨询定制方案</span>
            //             </div>
            //             <div className="consult-form">
            //                 <div className="consult-form-item">
            //                     <Input placeholder="请输入您的姓名" />
            //                 </div>
            //                 <div className="consult-form-item">
            //                     <Input placeholder="请输入您的单位" />
            //                 </div>
            //                 <div className="consult-form-item">
            //                     <Input placeholder="请输入您的联系方式" />
            //                 </div>
            //                 <div className="consult-form-item">
            //                     <Button type="primary" ghost block shape="round">立即咨询</Button>
            //                 </div>
            //             </div>
            //         </div>
            //     </div>
            // )
        }

        renderBody() {
            return (
                <>
                    <div className="content">
                        <Banner.Component extraClass="large" bimg="assets/images/banner/xuanz-banner.jpg" cimg="" text={
                            <div className="home-banner-text">
                                <div className="banner-text-name1"><img src="assets/images/banner/xz-text.png" /></div>
                                <div className="banner-text-name2 mt25">
                                    全国31个省，2400多个市县区精准对接
                                </div>
                            </div>}
                        />
                        {this.renderChoose()}
                        {this.renderProcess()}
                        {this.renderGround()}
                        {this.renderStrategic()}
                        {this.renderNews()}
                        {this.renderConsult()}
                        <div className="scoll-top">
                            <BackTop visibilityHeight={50} />
                        </div>
                    </div>
                </>
            );
        }
    }

    export const Page = template(Component, (state) => state[Namespaces.selection]);
}
